export const REDUCERS = {
  USER: 'user',
  PAYMENTS: 'payments',
  ACCOUNTS: 'accounts',
  APP: 'app',
};
